export const CARD_PADDING = 24;
export const GRID_GAP = 24;
export const GRID_PADDING = 40;
export const LINE_HEIGHT = 24;
export const IDEAS_UPLOADER_ID = 'ideas';
